import styled from 'styled-components';

export const AddRemovePageButton = styled.button`
  position: absolute;
  ${({ position }) => (position === 'top' ? 'top: 0;' : 'bottom: 0;')};
  right: 0;
  cursor: pointer;
  opacity: 0;
  margin: 0.75rem;
  background-color: white;
  color: ${({ color }) => color};
  border: ${({ color }) => `1px solid ${color}`};
  border-radius: 4px;
  padding: 2px 6px 2px 6px;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;

  &:hover {
    opacity: 1;
  }
`;

export const PDFPageOverlay = styled.div`
  pointer-events: none;
  position: absolute;
  top: ${({ page, pageAboveHeight, scale }) =>
    pageAboveHeight + (16 / scale) * page + 'px'};
  width: ${({ width }) => (width ? width + 'px' : '100%')};
  height: ${({ height }) => (height ? height + 'px' : '100%')};
  z-index: 2;
  margin-left: ${({ scale }) => 16 / scale + 'px'};
`;

export const RelativeContainer = styled.div`
  position: relative;
  width: ${({ isPreview }) => (isPreview ? '100vw' : '80vw')};
  min-height: 100%;
  overflow-y: auto;
`;

export const DocumentOverlay = styled.div`
  pointer-events: none;
  position: absolute;
  top: 16px;
  left: 0;
  scale: ${({ scalingFactor }) => scalingFactor};
`;

export const ScaledContainer = styled.div`
  scale: 1;
  height: 100%;
  @media only screen and (max-width: 768px) {
    overflow-x: hidden;
  }
`;
